import { Component, OnInit, inject, output } from '@angular/core';
import { BlogFilter } from 'src/app/common/BlogFilter';
import { BlogService } from 'src/app/services/blog.service';
import { DateRangeFilterComponent } from '../date-range-filter/date-range-filter.component';
import { FilterCardComponent } from '../filter-card/filter-card.component';
import { isDefaultFilter } from 'src/app/common/filter-state';

@Component({
    imports: [DateRangeFilterComponent, FilterCardComponent],
    selector: 'app-blog-search-box',
    templateUrl: './blog-search-box.component.html'
})
export class BlogSearchBoxComponent implements OnInit {
  private blogService = inject(BlogService);

  public filter: BlogFilter = new BlogFilter();

  readonly searchCriteria = output<BlogFilter>();

  /** What the page opened with — the yardstick for the reset button (#228). */
  private defaults: BlogFilter = new BlogFilter();

  public get isFiltered(): boolean {
    return !isDefaultFilter({ ...this.filter }, { ...this.defaults });
  }

  public resetFilter(): void {
    this.filter = new BlogFilter(this.defaults.validFrom, this.defaults.validTo);
    this.searchThis();
  }

  ngOnInit(): void {
    this.filter = this.blogService.getDefaultFilter();
    this.defaults = { ...this.filter };
  }

  searchThis() {
    this.searchCriteria.emit(this.filter);
  }

}
